export default __webpack_public_path__ + "static/media/dieselEuro5.fc23e057.png";